
import './App.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './componets/Header';
import HeroSection from './componets/HeroSlider';
import Footer from './componets/Footer';
import AboutPage from './componets/AboutPage';
import ServiceArea from './pages/ServiceArea';
import GallerySection from './pages/GallerySection';
import Booking from './pages/Booking';
import ContactSection from './pages/ContactSection';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Enquiry from './pages/Enquiry';
import Packages from './pages/Packages';
import Ourfleets from './pages/Ourfleets';
import Mumbaitogoacabs from './pages/Mumbai to Goa Cabs';
import Mumbaioutstationcabs from './pages/Mumbai Outstation Cabs';
import Mumbaitomahabaleshwarcab from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitoshirdicab from './pages/Mumbai to Shirdi Cab';
import Mumbainashikcab from './pages/Mumbai Nashik Cab';
import Mumbaitokolhapurcabs from './pages/Mumbai to Kolhapur Cab';
import Mumbaitopunecabs from './pages/Mumbai to Pune Cab';
import Mumbaitoaurangabadcab from './pages/Mumbai to Aurangabad Cab';
import Mumbaitobhimashankarcab from './pages/Mumbai to Bhimashankar Cab';
import Mumbaitoashtavinayakcabservice from './pages/Mumbai to Ashtavinayak Cab Service';
import Mumbaitofivejyotilingacab from './pages/Mumbai to 5 Jyotirlinga Cab';
import Mumbaitolonavalacabs from './pages/Mumbai to Lonavala Cab';
import Mumbaitokonkandarshancab from './pages/Mumbai to Konkan Darshan Cab Booking';
import Mumbaitoalibaugcab from './pages/Mumbai to Alibaug Cab';
import Mumbaitoahmednagarcab from './pages/Mumbai to Ahmednagar Cab';
import Mumbaitomatherancabs from './pages/Mumbai to Matheran Cab';
import Mumbaitojalgaon from './pages/Mumbai to Jalgaon  Dhule Cab';
import Mumbaitolavasacab from './pages/Mumbai to Lavasa Cab';
import Mumbaitopanchganicab from './pages/Mumbai to Panchgani Cab';
import Mumbaitokhandalataxifare from './pages/Mumbai to Khandala Taxi Fare';
import Mumbaitosuratcab from './pages/Mumbai to Surat Cab';
import Mumbaitoahmedabadcab from './pages/Mumbai to Ahmedabad Cab';
import Mumbaitonarmadaparikramacab from './pages/Mumbai to Narmada Parikrama Cab Booking';
import Mumbaitovadodaracab from './pages/Mumbai to Vadodara Cab';
import Mumbaitodamantaxi from './pages/Mumbai to Daman Taxi';
import Mumbaitovapicab from './pages/Mumbai to Vapi Cab';
import Mumbaitobanglore from './pages/Mumbai to Bangalore Cab';
import Mumbaitoindorecab from './pages/Mumbai to Indore Cab';
import Mumbaitojaipurtaxi from './pages/Mumbai to Jaipur Taxi';
import Mumbaiairporttopunecabs from './pages/Mumbai Airport to Pune Cabs';
import Mumbaitoimagicacab from './pages/Mumbai to Imagica Cab';
import Cabserviceinmumbai from './pages/Cab Service in Mumbai';
import Besttaxiserviceinmumbai from './pages/Best Taxi Service in Mumbai';
import Onlinetaxibookingmumbai from './pages/Online Taxi Booking Mumbai';
import Mumbaidarshancabs from './pages/Mumbai Darshan Cabs';
import Weddingcarrentalmumbai from './pages/Wedding Car Rental Mumbai';
import Onewaycabservice from './pages/One Way Cab Service';
import Corporatecabserviceinmumbai from './pages/Corporate Cab Services in Mumbai';
import Cabcompaniesinmumbai from './pages/Cab Companies in Mumbai';
import Mumbaicarrentalservice from './pages/Mumbai Car Rental Service';
import Roundtripcabbookingmumbai from './pages/Round Trip Cab Booking Mumbai';
import Cabserviceinthane from './pages/Cab Service in Thane';
import Cabservicenearmemumbai from './pages/Cab Service Near Me Mumbai';
import Swiftdzireonrentinmumbai from './pages/Swift Dzire on Rent in Mumbai';
import Cabserviceinnavimumbai from './pages/Cab Service in Navi Mumbai';
import Taxiserviceatmumbaiiternationalairport from './pages/Taxi Service at Mumbai International Airport';
import Cabserviceinkalyan from './pages/Cab Service in Kalyan  Dombivali';
import Innovacarrentalmumbai from './pages/Innova Car Rental Mumbai';
import Innovacrystaonrentinmumbai from './pages/Innova Crysta on Rent in Mumbai';
import Ertigaonrentinpune from './pages/Ertiga on Rent in Mumbai';
import Sedancabservicemumbai from './pages/Sedan Cab Service Mumbai';
import Tempotravelleronrentmumbai from './pages/Tempo Traveller on Rent Mumbai';
import Minibusonrentinmumbai from './pages/Mini Bus on Rent in Mumbai';
import Kiacarencecabservice from './pages/Kia Carens Cab Service in Mumbai';
import Toyotaetiononrentinmumbai from './pages/Toyota Etios on Rent in Mumbai';
import Carrentalmumbai from './pages/Car Rental Mumbai';
import Exploreindiapancab from './pages/Explore India  Pan India Cab Booking Services';
import Mumbaitopandharpur from './pages/Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking';
import Outstationtaxiserviceinmumbai from './pages/Outstation Taxi Service in Mumbai';
import Carhireforoutstationinmumbai from './pages/Car Hire for Outstation in Mumbai';
import Mumbaitohyderabadcab from './pages/Mumbai to Hyderabad Cabs';
import Mumbaicabservice from './pages/Mumbai Cab Service';
import Bestcabserviceinmumbai from './pages/Best Cab Service in Mumbai';
import Mumbaitoayodhyacab from './pages/Mumbai to Ayodhya Cab';
import Mumbaitosaputara from './pages/Mumbai to Saputara Cabs';
import Mumbaitobhopalcab from './pages/Mumbai to Bhopal Cab';
import Mumbaitotelanganacabservice from './pages/Mumbai to Telangana Cab Service';
import Mumbaitoshanishingnapur from './pages/Mumbai to Shani Shingnapur Cab';
import Mumbaitotrimkeshwar from './pages/Mumbai to Trimbakeshwar Cab';
import Mumbaiairporttovadodaracab from './pages/Mumbai Airport to Vadodara Cab';
import Mumbaiairporttosolapur from './pages/Mumbai to Solapur Cab';
import Mumbaitoratnagiricab from './pages/Mumbai to Ratnagiri Cab';
import Mumbaitogrishneshwar from './pages/Mumbai to Grishneshwar Cab';
import Mumbaitopalgharcab from './pages/Mumbai to Palghar Cab';
import Mumbaitoujjaincab from './pages/Mumbai to Ujjain Cab';
import Mumbaitojaipurcab from './pages/Mumbai to Jaipur Cab';
import Mumbaitogujratcab from './pages/Mumbai to Gujarat Cab';
import Innovaonrentmumbai from './pages/Innova on Rent Mumbai';
import Kiacarensonrentinmumbai from './pages/Kia Carens on Rent in Mumbai';
import ContactButtons from './componets/ContactButtons';
import ScrollToTop from './componets/ScrollToTop';
import Career from './componets/Career';
import OurNetwork from './componets/OurNetwork';


function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<ServiceArea />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/Career" element={<Career />} />
        <Route path="/OurNetwork" element={<OurNetwork />} />
   


<Route path="/mumbai-outstation-cabs" element={<Mumbaioutstationcabs />} />
<Route path="/mumbai-to-mahabaleshwar-cab" element={<Mumbaitomahabaleshwarcab />} />
<Route path="/mumbai-to-goa-cabs" element={<Mumbaitogoacabs />} />
<Route path="/mumbai-to-shirdi-cab" element={<Mumbaitoshirdicab />} />
<Route path="/mumbai-nashik-cab" element={<Mumbainashikcab />} />
<Route path="/mumbai-to-kolhapur-cab" element={<Mumbaitokolhapurcabs />} />
<Route path="/mumbai-to-pune-cab" element={<Mumbaitopunecabs />} />
<Route path="/mumbai-to-aurangabad-cab" element={<Mumbaitoaurangabadcab />} />
<Route path="/mumbai-to-bhimashankar-cab" element={<Mumbaitobhimashankarcab />} />
<Route path="/mumbai-to-ashtavinayak-cab-service" element={<Mumbaitoashtavinayakcabservice />} />
<Route path="/mumbai-to-5-jyotirlinga-cab" element={<Mumbaitofivejyotilingacab />} />
<Route path="/mumbai-to-lonavala-cab" element={<Mumbaitolonavalacabs />} />
<Route path="/mumbai-to-konkan-darshan-cab-booking" element={<Mumbaitokonkandarshancab />} />
<Route path="/mumbai-to-alibaug-cab" element={<Mumbaitoalibaugcab />} />
<Route path="/mumbai-to-ahmednagar-cab" element={<Mumbaitoahmednagarcab />} />
<Route path="/mumbai-to-matheran-cab" element={<Mumbaitomatherancabs />} />
<Route path="/mumbai-to-jalgaon-dhule-cab" element={<Mumbaitojalgaon />} />
<Route path="/mumbai-to-lavasa-cab" element={<Mumbaitolavasacab />} />
<Route path="/mumbai-to-panchgani-cab" element={<Mumbaitopanchganicab />} />
<Route path="/mumbai-to-khandala-taxi-fare" element={<Mumbaitokhandalataxifare />} />
<Route path="/mumbai-to-surat-cab" element={<Mumbaitosuratcab />} />
<Route path="/mumbai-to-ahmedabad-cab" element={<Mumbaitoahmedabadcab />} />
<Route path="/mumbai-to-narmada-parikrama-cab-booking" element={<Mumbaitonarmadaparikramacab />} />
<Route path="/mumbai-to-vadodara-cab" element={<Mumbaitovadodaracab />} />
<Route path="/mumbai-to-daman-taxi" element={<Mumbaitodamantaxi />} />
<Route path="/mumbai-to-vapi-cab" element={<Mumbaitovapicab />} />
<Route path="/mumbai-to-bangalore-cab" element={<Mumbaitobanglore />} />
<Route path="/mumbai-to-indore-cab" element={<Mumbaitoindorecab />} />
<Route path="/mumbai-to-jaipur-taxi" element={<Mumbaitojaipurtaxi />} />
<Route path="/mumbai-airport-to-pune-cabs" element={<Mumbaiairporttopunecabs />} />
<Route path="/mumbai-to-imagica-cab" element={<Mumbaitoimagicacab />} />
<Route path="/cab-service-in-mumbai" element={<Cabserviceinmumbai />} />
<Route path="/best-taxi-service-in-mumbai" element={<Besttaxiserviceinmumbai />} />
<Route path="/online-taxi-booking-mumbai" element={<Onlinetaxibookingmumbai />} />
<Route path="/mumbai-darshan-cabs" element={<Mumbaidarshancabs />} />
<Route path="/wedding-car-rental-mumbai" element={<Weddingcarrentalmumbai />} />
<Route path="/one-way-cab-service" element={<Onewaycabservice />} />
<Route path="/corporate-cab-services-in-mumbai" element={<Corporatecabserviceinmumbai />} />
<Route path="/cab-companies-in-mumbai" element={<Cabcompaniesinmumbai />} />
<Route path="/mumbai-car-rental-service" element={<Mumbaicarrentalservice />} />
<Route path="/round-trip-cab-booking-mumbai" element={<Roundtripcabbookingmumbai />} />
<Route path="/cab-service-in-thane" element={<Cabserviceinthane />} />
<Route path="/cab-service-near-me-mumbai" element={<Cabservicenearmemumbai />} />
<Route path="/swift-dzire-on-rent-in-mumbai" element={<Swiftdzireonrentinmumbai />} />
<Route path="/cab-service-in-navi-mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/taxi-service-at-mumbai-international-airport" element={<Taxiserviceatmumbaiiternationalairport />} />
<Route path="/cab-service-in-kalyan-dombivali" element={<Cabserviceinkalyan />} />
<Route path="/innova-car-rental-mumbai" element={<Innovacarrentalmumbai />} />
<Route path="/innova-crysta-on-rent-in-mumbai" element={<Innovacrystaonrentinmumbai />} />
<Route path="/ertiga-on-rent-in-mumbai" element={<Ertigaonrentinpune />} />
<Route path="/sedan-cab-service-mumbai" element={<Sedancabservicemumbai />} />
<Route path="/tempo-traveller-on-rent-mumbai" element={<Tempotravelleronrentmumbai />} />
<Route path="/mini-bus-on-rent-in-mumbai" element={<Minibusonrentinmumbai />} />
<Route path="/kia-carens-cab-service-in-mumbai" element={<Kiacarencecabservice />} />
<Route path="/toyota-etios-on-rent-in-mumbai" element={<Toyotaetiononrentinmumbai />} />
<Route path="/car-rental-mumbai" element={<Carrentalmumbai />} />
<Route path="/explore-india-pan-india-cab-booking-services" element={<Exploreindiapancab />} />
<Route path="/mumbai-to-pandharpur-akkalkot-tuljapur-cab-booking" element={<Mumbaitopandharpur />} />
<Route path="/outstation-taxi-service-in-mumbai" element={<Outstationtaxiserviceinmumbai />} />
<Route path="/car-hire-for-outstation-in-mumbai" element={<Carhireforoutstationinmumbai />} />
<Route path="/mumbai-to-hyderabad-cabs" element={<Mumbaitohyderabadcab />} />
<Route path="/mumbai-cab-service" element={<Mumbaicabservice />} />
<Route path="/best-cab-service-in-mumbai" element={<Bestcabserviceinmumbai />} />
<Route path="/mumbai-to-ayodhya-cab" element={<Mumbaitoayodhyacab />} />
<Route path="/mumbai-to-saputara-cabs" element={<Mumbaitosaputara />} />
<Route path="/mumbai-to-bhopal-cab" element={<Mumbaitobhopalcab />} />
<Route path="/mumbai-to-telangana-cab-service" element={<Mumbaitotelanganacabservice />} />
<Route path="/mumbai-to-shani-shingnapur-cab" element={<Mumbaitoshanishingnapur />} />
<Route path="/mumbai-to-trimbakeshwar-cab" element={<Mumbaitotrimkeshwar />} />
<Route path="/mumbai-airport-to-vadodara-cab" element={<Mumbaiairporttovadodaracab />} />
<Route path="/mumbai-to-solapur-cab" element={<Mumbaiairporttosolapur />} />
<Route path="/mumbai-to-ratnagiri-cab" element={<Mumbaitoratnagiricab />} />
<Route path="/mumbai-to-grishneshwar-cab" element={<Mumbaitogrishneshwar />} />
<Route path="/mumbai-to-palghar-cab" element={<Mumbaitopalgharcab />} />
<Route path="/mumbai-to-ujjain-cab" element={<Mumbaitoujjaincab />} />
<Route path="/mumbai-to-jaipur-cab" element={<Mumbaitojaipurcab />} />
<Route path="/mumbai-to-gujarat-cab" element={<Mumbaitogujratcab />} />
<Route path="/innova-on-rent-mumbai" element={<Innovaonrentmumbai />} />
<Route path="/kia-carens-on-rent-in-mumbai" element={<Kiacarensonrentinmumbai />} />


      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
